export const query_base_app_setting = `
query getBaseAppSetting($key: String!) {
  base_app_setting(where: { Key: {_eq: $key}}) {
    Id
    Key
    Value
  }
}`;
export const query_base_app_setting_all_by_key = `
query getBaseAppSettingByKey($key: String!) {
  base_app_setting(where: { Key: {_eq: $key}}) {
    Id
    Key
    Value
    TenantId
  }
}`;
export const query_base_security_area = `
query getBaseSecurityArea {
  base_security_area(order_by: {Order: asc}) {
    Id
    Key
    Value
    Description
    Order
  }
}`;
export const query_base_all = `
query getBaseAll($tenantId: String!) {
  base_mezzo_pagamento(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_natura_prestazione(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_natura_rapporto(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_origine_fondi(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_scopo_prestazione(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_tipo_anagrafica(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_tipo_documento(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
    PersonType
    DocumentTypeId
    ValidityMonths
    ValidityOffsetDays
    NextBirthDay
  }
  base_tipo_identificazione(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_tipo_personalita(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_genere(where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_paese(order_by: {Nome: asc}) {
    Id
    Identificativo
    Nome
    IsRischio
    CodiceAt
  }
  base_provincia(order_by: {Nome: asc}) {
    Id
    Sigla
    Nome
    Rischio
  }
  base_comune(where: {DataSoppressione: {_is_null: true}}, order_by: {Nome: asc}) {
    Id
    Codice
    Nome
    Provincia
    CodBelfiore
  }
  base_tipo_partecipazione {
    Id
    Key
    Nome
    Descrizione
  }
  base_tipo_patrimonio (where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Order: asc}){
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
  base_tipo_reddito (where: {_or: [{IsSystem: {_eq: true}}, {TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}, order_by: {Order: asc}){
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;

//#region base_paese
export const query_base_paese = `
query getBasePaese {
  base_paese(order_by: {Nome: asc}) {
    Id
    Identificativo
    Nome
    IsRischio
    CodiceAt
  }
}`;
export const query_base_paese_byIdent = `
query getBasePaeseByIdent($identificativo: String!) {
  base_paese(where: {Identificativo: {_eq: $identificativo}}) {
    Id
    Identificativo
    Nome
    IsRischio
    CodiceAt
  }
}`;
export const query_base_paese_byNome = `
query getBasePaeseByNome($nome: String!) {
  base_paese(where: {Nome: {_ilike: $nome}}) {
    Id
    Identificativo
    Nome
    IsRischio
    CodiceAt
  }
}`;
export const query_base_paese_byCodAt = `
query getBaseComuneByCodAt($codiceAt: String!) {
  base_paese(where: {CodiceAt: {_ilike: $codiceAt}}) {
    Id
    Identificativo
    Nome
    IsRischio
    CodiceAt
  }
}`;
//#endregion

//#region base_provincia
export const query_base_provincia = `
query getBaseProvincia {
  base_provincia(order_by: {Nome: asc}) {
    Id
    Sigla
    Nome
    Rischio
  }
}`;
export const query_base_provincia_byNome = `
query getBasePaeseByNome($nome: String!) {
  base_provincia(where: {Nome: {_ilike: $nome}}) {
    Id
    Sigla
    Nome
    Rischio
  }
}`;
export const query_base_provincia_byIdent = `
query getBaseProvinciaByIdent($sigla: String!) {
  base_provincia(where: {Sigla: {_eq: $sigla}}) {
    Id
    Sigla
    Nome
    Rischio
  }
}`;
//#endregion

//#region base_comune
export const query_base_comune = `
query getBaseComune($provincia: String!) {
  base_comune(where: {Provincia: {_eq: $provincia}, DataSoppressione: {_is_null: true}}) {
    Id
    Codice
    Nome
    Provincia
    CodBelfiore
  }
}`;
export const query_base_comune_forCerved = `
query getBaseComuneForCerved($provincia: String!) {
  base_comune(where: {Provincia: {_eq: $provincia}}) {
    Id
    Codice
    Nome
    Provincia
    CodBelfiore
    DataSoppressione
  }
}`;
export const query_base_stdcodes_byCodISTAT = `
query getBaseStdCodesByCodISTAT($codici: [String!]!) {
  base_stdcodes_comune(where: {CodISTAT: {_in: $codici}}) {
    CodISTAT
    CodiceBelfiore
  }
}`;
export const query_base_comune_byNome = `
query getBaseComuneByNome($nome: String!) {
  base_comune(where: {Nome: {_ilike: $nome}, DataSoppressione: {_is_null: true}}) {
    Id
    Codice
    Nome
    Provincia
    CodBelfiore
  }
}`;
export const query_base_comune_byCodBelfiore = `
query getBaseComuneByCodBelfiore($codBelfiore: String!) {
  base_comune(where: {CodBelfiore: {_ilike: $codBelfiore}}) {
    Id
    Codice
    Nome
    Provincia
    CodBelfiore
    DataSoppressione
  }
}`;
export const query_base_comune_byId = `
query getBaseComuneById($id: Int!) {
  base_comune(where: {Id: {_eq: $id}}) {
    Id
    Codice
    Nome
    Provincia
    CodBelfiore
  }
}`;
export const query_base_stcodes_byCodBelfiore = `
query getBaseStCodesByCodBelfiore($codBelfiore: String!) {
  base_stdcodes_comune(where: {CodiceBelfiore: {_ilike: $codBelfiore}}) {
    DenominazioneApiciStd
    MultiCAP
    CAP
  }
}`;

//#endregion

//#region base_mezzo_pagamento
export const query_base_mezzo_pagamento = `
query getBaseMezzoPagamento($tenantId: String!) {
  base_mezzo_pagamento(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_mezzo_pagamento_byTenant = `
query getBaseMezzoPagamentoByTenant($tenantId: String!) {
  base_mezzo_pagamento(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_mezzo_pagamento_byValue = `
query getBaseMezzoPagamentoByValue($tenantId: String!, $value: String!) {
  base_mezzo_pagamento(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_mezzo_pagamento_byId = `
query getBaseMezzoPagamentoById($id: Int!) {
  base_mezzo_pagamento_by_pk(Id: $id) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_natura_prestazione
export const query_base_natura_prestazione = `
query getBaseNaturaPrestazione($tenantId: String!) {
  base_natura_prestazione(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_natura_prestazione_byTenant = `
query getBaseNaturaPrestazioneByTenant($tenantId: String!) {
  base_natura_prestazione(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_natura_prestazione_byKey = `
query getBaseNaturaPrestazioneByKey($key: String!) {
  base_natura_prestazione(where: {Key: {_eq: $key}}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_natura_prestazione_byValue = `
query getBaseNaturaPrestazioneByValue($tenantId: String!, $value: String!) {
  base_natura_prestazione(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_natura_rapporto
export const query_base_natura_rapporto = `
query getBaseNaturaRapporto($tenantId: String!) {
  base_natura_rapporto(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_natura_rapporto_byTenant = `
query getBaseNaturaRapportoByTenant($tenantId: String!) {
  base_natura_rapporto(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_natura_rapporto_byValue = `
query getBaseNaturaRapportoByValue($tenantId: String!, $value: String!) {
  base_natura_rapporto(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_origine_fondi
export const query_base_origine_fondi = `
query getBaseOrigineFondi($tenantId: String!) {
  base_origine_fondi(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_origine_fondi_byTenant = `
query getBaseOrigineFondiByTenant($tenantId: String!) {
  base_origine_fondi(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_origine_fondi_byValue = `
query getBaseOrigineFondiByValue($tenantId: String!, $value: String!) {
  base_origine_fondi(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_origine_fondi_byId = `
query getBaseOrigineFondiById($id: Int!) {
  base_origine_fondi_by_pk(Id: $id) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_scopo_prestazione
export const query_base_scopo_prestazione = `
query getBaseScopoPrestazione($tenantId: String!) {
  base_scopo_prestazione(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_scopo_prestazione_byTenant = `
query getBaseScopoPrestazioneByTenant($tenantId: String!) {
  base_scopo_prestazione(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_scopo_prestazione_byKey = `
query getBaseScopoPrestazioneById($key: String!) {
  base_scopo_prestazione(where: {Key: {_eq: $key}}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_scopo_prestazione_byValue = `
query getBaseScopoPrestazioneByValue($tenantId: String!, $value: String!) {
  base_scopo_prestazione(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_tipo_anagrafica
export const query_base_tipo_anagrafica = `
query getBaseTipoAnagrafica($tenantId: String!) {
  base_tipo_anagrafica(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_anagrafica_byTenant = `
query getBaseTipoAnagraficaByTenant($tenantId: String!) {
  base_tipo_anagrafica(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_anagrafica_byId = `
query getBaseTipoAnagraficaById($id: Int!) {
  base_tipo_anagrafica(Id: $id) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_anagrafica_byKey = `
query getBaseTipoAnagraficaByKey($key: String!) {
  base_tipo_anagrafica(where: {Key: {_eq: $key}}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_tipo_documento
export const query_base_tipo_documento = `
query getBaseTipoDocumento($tenantId: String!) {
  base_tipo_documento(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
    PersonType
  }
}`;
export const query_base_tipo_documento_system = `
query getBaseTipoDocumentoSystem {
  base_tipo_documento(where: {IsSystem: {_eq: true}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
    PersonType
  }
}`;
export const query_base_tipo_documento_byTenant = `
query getBaseTipoDocumentoByTenant($tenantId: String!) {
  base_tipo_documento(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
    PersonType
  }
}`;
export const query_base_tipo_documento_byId = `
query getBaseTipoDocumentoById($id: Int!) {
  base_tipo_documento_by_pk(Id: $id) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
    PersonType
    DocumentTypeId
    ValidityMonths
    ValidityOffsetDays
    NextBirthDay
  }
}`;
export const query_base_tipo_documento_byValue = `
query getBaseTipoDocumentoByValue($tenantId: String!, $value: String!) {
  base_tipo_documento(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_tipo_identificazione
export const query_base_tipo_identificazione = `
query getBaseTipoIdentificazione($tenantId: String!) {
  base_tipo_identificazione(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_identificazione_byTenant = `
query getBaseTipoIdentificazioneByTenant($tenantId: String!) {
  base_tipo_identificazione(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_identificazione_byValue = `
query getBaseTipoIdentificazioneByValue($tenantId: String!, $value: String!) {
  base_tipo_identificazione(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_tipo_personalita
export const query_base_tipo_personalita = `
query getBaseTipoPersonalita($tenantId: String!) {
  base_tipo_personalita(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_personalita_byTenant = `
query getBaseTipoPersonalitaByTenant($tenantId: String!) {
  base_tipo_personalita(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_tipo_personalita_byValue = `
query getBaseTipoPersonalitaByValue($tenantId: String!, $value: String!) {
  base_tipo_personalita(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
//#endregion

//#region base_tipo_prestazione
export const query_base_tipo_prestazione = `
query getBaseTipoPrestazione($tenantType: Int!) {
  base_tipo_prestazione(where: {BaseTenantTipoId: {_eq: $tenantType}},order_by: {Nome: asc}) {
    Id
    Nome
    Rischio
    Regole
    DataInizioValidita
    DataFineValidita
  }
}`;
export const query_base_tipo_prestazione_ByDate = `
query getBaseTipoPrestazioneByDate($tenantType : Int!,$dateStart : date!){
  base_tipo_prestazione(
    where:
    {BaseTenantTipoId: {_eq:$tenantType},
    _and : [ {DataInizioValidita: {_lte:$dateStart}, DataFineValidita: {_gte:$dateStart}}]},
    order_by: {Nome: asc}){
    Id
    Nome
    Rischio
    Regole
    DataInizioValidita
    DataFineValidita
  }
}`;
export const query_base_tipo_prestazione_all = `
query getBaseTipoPrestazioneAll {
  base_tipo_prestazione {
    Id
    BaseTenantTipoId
    Nome
    Rischio
    Regole
  }
}`;
//#endregion

//#region base_tipo_partecipazione
export const query_base_tipo_partecipazione = `
query getBaseTipoPartecipazione {
  base_tipo_partecipazione {
    Id
    Key
    Nome
    Descrizione
  }
}`;
//#endregion

//#region base_tipo_tenant
export const query_base_tipo_tenant = `
query getBaseTipoTenant {
  base_tipo_tenant(order_by: {Order: asc}) {
    Id
    Key
    Value
    Order
  }
}`;
//#endregion

//#region base_valuta
export const query_base_valuta = `
query getBaseValuta {
  base_valuta(order_by: {IsoCode: asc}) {
    Id
    Country
    Currency
    IsoCode
    UicCode
    EurRate
    UsdRate
    UsdExcConv
    UsdExcConvCode
    RefDate
  }
}`;
export const query_base_valuta_byISO = `
query getBaseValutaByIso($isoCode: String!) {
  base_valuta(where: {IsoCode: {_eq: $isoCode}}) {
    Id
    Country
    Currency
    IsoCode
    UicCode
    EurRate
    UsdRate
    UsdExcConv
    UsdExcConvCode
    RefDate
  }
}`;
//#endregion

//#region base_genere
export const query_base_genere = `
query getBaseGenere($tenantId: String!) {
  base_genere(where: {_or: [{_or: [{IsSystem: {_eq: true}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}}]}]}, order_by: {Value: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_genere_byTenant = `
query getBaseGenereByTenant($tenantId: String!) {
  base_genere(where: {IsSystem: {_eq: false}, TenantId: {_eq: $tenantId}}, order_by: {Order: asc}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_genere_byValue = `
query getBaseGenereByValue($tenantId: String!, $value: String!) {
  base_genere(where: {_or: [{_or: [{IsSystem: {_eq: true}, Value: {_eq: $value}}]}, {_or: [{TenantId: {_eq: $tenantId}, IsSystem: {_eq: false}, Value: {_eq: $value}}]}]}) {
    Id
    TenantId
    Key
    Value
    Order
    IsSystem
  }
}`;
export const query_base_genere_inAnagrafica = `
query getBaseGenereInAnagrafica($tenantId: String!) {
  anagrafica(where: {anagrafica_fascicolos: {fascicolo: {TenantId: {_eq: $tenantId}}}}, distinct_on: GenereId) {
    GenereId
  }
}`;
//#endregion

//#region base_rischio_grado
export const query_base_rischio_grado_byTenantTipo = `
query getBaseRischioGradoByTenantTipo($tenantTipoId: Int!) {
  base_rischio_grado(where: {BaseTenantTipoId: {_eq: $tenantTipoId}}) {
    Id
    TipoRischio
    GradoRischio
    AdeguataVerifica
    ValoreRischioDa
    ValoreRischioA
    Colore
    Offset
  }
}`;
//#endregion

//#region base_indicatore_anomalia
export const query_base_indicatore_anomalia = `
query getBaseIndicatoreAnomalia {
  base_indicatore_anomalia(order_by: {Section: asc, Point: asc, SubPoint: asc}) {
    Id
    ParentId
    Section
    Point
    SubPoint
    Description
    IsVisible
  }
}`;
//#endregion